import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import {
  setFilepathBlobUrl,
  setUploadFormData,
  resetUploadState,
} from 'store/buku-tarif/bukuTarifSlice';
import { useUploadFile } from './useUploadFile';
import { useCreateTariffBook } from './useCreateTariffBook';

export const useUploadTariffBookFlow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleUpload: uploadFile, loading: uploadLoading } = useUploadFile();
  const { handleCreate: createTariffBook, loading: createLoading } =
    useCreateTariffBook();

  const loading = uploadLoading || createLoading;

  const handleUploadFlow = useCallback(
    async (formData) => {
      const formDataBulk = new FormData();
      formDataBulk.append('file', formData.file);

      const uploadResponse = await uploadFile(formDataBulk);
      if (!uploadResponse) return false;

      const fileData = {
        filename: uploadResponse?.data?.filename,
        filepath: uploadResponse?.data?.filepath,
      };

      dispatch(
        setUploadFormData({
          file: fileData,
          starting_date: formData.starting_date,
          country_id: formData.country_id,
          organization_name: formData.organization_name,
        })
      );

      const payload = {
        file: fileData,
        starting_date: formData?.starting_date
          ? dayjs(formData.starting_date).format('YYYY-MM-DD')
          : undefined,
        country_id: formData?.country_id || undefined,
        organization_name: formData?.organization_name || undefined,
        activate_discount_rule: Boolean(formData?.activate_discount_rule),
        discount_rule: formData?.activate_discount_rule
          ? formData?.discount_rule || undefined
          : undefined,
      };

      const createResponse = await createTariffBook(payload);
      if (!createResponse) return false;

      dispatch(setUploadFormData({ id: createResponse?.data?.id }));
      navigate('/buku-tarif/upload');
      return true;
    },
    [uploadFile, createTariffBook, dispatch, navigate]
  );

  const dispatchFilePath = useCallback(
    (blobUrl) => {
      dispatch(setFilepathBlobUrl(blobUrl));
    },
    [dispatch]
  );

  const resetState = useCallback(() => {
    dispatch(resetUploadState());
  }, [dispatch]);

  return { handleUploadFlow, loading, dispatchFilePath, resetState };
};
